import {ListResponseTrackerEventBean, TrackerEventBean} from 'common/api/api.ts';
import {trackerEventApi} from 'common/api/entitiesApi.tsx';
import {ListCard} from 'common/components/ListCard.tsx';
import {SearchInput} from 'common/components/SearchInput.tsx';
import {ListFilters, useAppContext} from 'common/context/AppContext.tsx';
import {CommonRoutes} from 'common/context/commonRoutes.ts';
import {COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH} from 'common/util/constants';
import {initListFilters, useListFilters} from 'common/util/useListFilters.ts';
import {apiCall} from 'common/util/Util.tsx';
import dayjs from 'dayjs';
import {useState} from 'react'
import {Link} from 'react-router-dom';

const TrackerEventList = () => {
    const appContext = useAppContext()

    const [filters, setFilters] = useState<ListFilters>(initListFilters())
    const {setFilter} = useListFilters(setFilters)

    const [loading, setLoading] = useState<boolean>(false)
    const [listData, setListData] = useState<ListResponseTrackerEventBean>()

    const loadData = () => {
        apiCall(
            setLoading,
            appContext,
            () =>
                trackerEventApi.trackerEventPage(
                    filters.sort?.name,
                    filters.sort?.direction,
                    filters.name,
                    {query: {page: filters.page, size: filters.pageSize}}
                ),
            (data) => setListData(data)
        )
    }

    return (
        <>
            <ListCard
                loading={loading}
                title="Tracker Events"
                createName="Tracker Event"
                createRoute={CommonRoutes.TRACKER_EVENT_CREATE}
                filters={filters}
                setFilters={setFilters}
                listData={listData}
                loadData={loadData}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        width: COLUMN_ID_WIDTH
                    },
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        sorter: true,
                        className: 'list-table-name',
                        ellipsis: true,
                        render: (text: string, record: TrackerEventBean) => (
                            <Link style={{color: '#5888CF', minWidth: 100}} to={`/tracker-event/${record.id}/edit`}>
                                {text}
                            </Link>
                        ),
                        width: COLUMN_NAME_WIDTH
                    },
                    {
                        title: 'Support Price',
                        dataIndex: 'withPrice',
                        width: 90,
                        render: value => value ? 'Yes' : ''
                    },
                    {
                        title: 'Last Modified',
                        dataIndex: 'modified',
                        sorter: true,
                        width: 100,
                        render: (date) => date && dayjs(date).format('DD MMM YY')
                    }
                ]}
            >
                <SearchInput placeholder="Search by ID, Name, Token" width="250px" value={filters.name}
                             onChange={(value) => setFilter('name', value)}/>
            </ListCard>
        </>
    )
}

export default TrackerEventList